import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import 'react-toastify/dist/ReactToastify.css';
import '@szhsin/react-menu/dist/index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

Modal.setAppElement('#root')

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
